<!-- Header -->
<h3 mat-dialog-title translate>
    Attachments
</h3>

<!-- Body -->
<mat-dialog-content>
    <div style="display: flex; margin-bottom: 5px;" *ngFor="let attachment of attachments">
        <add-file [deletable]="true"
            style="flex-grow: 1"
            buttonLabel="Browse"
            [(fileName)]="attachment.FileName"
            [(fileExtension)]="attachment.FileExtension"
            [(fileString)]="attachment.Base64String"
            [(fileType)]="attachment.FileType"
            [fileSize]="attachment.size"
            (fileSizeChange)="setFileSize(attachment, $event)"
            [maxFileSize]="maxAttachmentSize"
            (changes)="attachment.IsFileUpload = true"></add-file>
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="OK" (clickEvent)="ok()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>
